import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid, Image } from "semantic-ui-react";
import { numberToArray } from "../../helpers/functional";
import { filteredAvailableRates } from "../../reducers";
import styles from "./styles.less";
import RateTableRow from "../RateTableRow/RateTableRow";
import { RawHTML, Ribbon } from "../common";

class RatesTable extends Component {
  constructor(props) {
    super(props);
    // const { rates, groupParam, shouldFilterAvailableRates } = this.props;
    this.state = {
      showAllRates: false,
      finishedRendering: false
    };

    this.state = {
      showAllRates: false,
      finishedRendering: false
    };
  }

  componentDidMount() {
    this.prepareData();
  }

  componentDidUpdate(prevProps) {
    const { selectedPaxId: newSelectedPaxId, rates: newRates } = this.props;
    const { selectedPaxId: oldSelectedPaxId, rates: oldRates } = prevProps;
    if (oldSelectedPaxId !== newSelectedPaxId || newRates != oldRates) {
      this.prepareData();
    }
  }

  prepareData = () => {
    const {
      rates,
      groupParam,
      shouldGroupByPackageId /*, shouldFilterAvailableRates*/
    } = this.props;

    const availableRates = filteredAvailableRates(rates);

    const ratesAsGroups = this.groupRatesByParam(
      availableRates,
      groupParam,
      shouldGroupByPackageId
    );
    this.setState({
      finishedRendering: true,
      ratesAsGroups
    });
  };

  expendRates = () => this.setState(() => ({ showAllRates: true }));

  groupRatesByParam = (rates, param, shouldGroupByPackageId) => {
    const ratesGropuedByParam = new Map();
    let tmpArray = new Array();
    let paramToGroup = param;
    rates &&
      rates.forEach(element => {
        if (shouldGroupByPackageId && element.isPackage) {
          paramToGroup = "packageID";
          if (element.parentID > 0) {
            paramToGroup = "parentID";
          }
        } else {
          paramToGroup = param;
        }
        if (!ratesGropuedByParam.has(element[paramToGroup])) {
          ratesGropuedByParam.set(element[paramToGroup], [element]);
        } else {
          tmpArray = ratesGropuedByParam.get(element[paramToGroup]);
          tmpArray.push(element);
          ratesGropuedByParam.set(element[paramToGroup], tmpArray);
          tmpArray = [];
        }
      });
    return ratesGropuedByParam;
  };

  renderRibbon = () => {
    const { isRtl, isMobileView, isIos, titles } = this.props;
    return (
      <div className={styles.ribbon}>
        <Ribbon
          text={titles.SpecialDeal}
          isRtl={!isRtl}
          wrapperClassName={cx(styles.ribbonWrapper, {
            [styles.ribbonWrapperRtl]: isRtl && !isMobileView,
            [styles.ribbonWrapperMobileView]: isMobileView && !isRtl,
            [styles.ribbonWrapperRtlMobileView]: isRtl && isMobileView,
            [styles.ribbonWrapperIosIsShit]: isIos
          })}
          textClassName={styles.ribbonWrapperText}
          shape="horizontal"
          vertical="top"
        />
      </div>
    );
  };

  renderRateRow = (rate, isDeal) => {
    const {
      titles,
      isRtl,
      showAvailability,
      lowAvailabilityCount,
      onItemClick,
      onReadeMoreClick,
      ShowCancellationPolicy,
      isClubActive,
      groupParam,
      showSimpleClubLoginModal,
      clubUserLoggedIn,
      clubPercentageDiscount,
      isDealPage,
      isIE,
      displayPriceWithoutTaxes,
      showPricePerNightThumb
    } = this.props;
    return (
      <RateTableRow
        key={rate.id + rate.roomId}
        isRtl={isRtl}
        titles={titles}
        rateId={rate.id}
        roomId={rate.roomId}
        planName={rate.planName}
        priceName={rate[groupParam]}
        price={rate.totalPrice}
        basePrice={rate.basePrice}
        simpleClubTotalPrice={rate.simpleClubTotalPrice}
        priceCode={rate.priceCode}
        planCode={rate.planCode}
        currencyCode={rate.currencyCode}
        currency={rate.currency}
        availability={rate.availability}
        allocationCode={rate.allocationCode}
        showAvailability={showAvailability}
        lowAvailabilityCount={lowAvailabilityCount}
        description={rate.planDescription}
        onClick={onItemClick}
        isPackage={rate.isPackage}
        ShowCancellationPolicy={ShowCancellationPolicy}
        showSimpleClubLoginModal={showSimpleClubLoginModal}
        isClubActive={isClubActive}
        clubUserLoggedIn={clubUserLoggedIn}
        clubPercentageDiscount={clubPercentageDiscount}
        onReadeMoreClick={onReadeMoreClick}
        isDeal={isDeal || isDealPage}
        isIE={isIE}
        displayPriceWithoutTaxes={displayPriceWithoutTaxes}
        showPricePerNightThumb={showPricePerNightThumb}
        displayPriceWithoutTaxes={displayPriceWithoutTaxes}
      />
    );
  };

  renderEmptyRates = numberOfPlacholders => {
    let placeHolders = numberToArray(numberOfPlacholders).map(num => (
      <Grid.Column
        key={num}
        mobile={16}
        tablet={8}
        computer={5}
        className={styles.rateWrapper}
      >
        <div className={styles.rateWrapper} />
      </Grid.Column>
    ));
    return placeHolders;
  };

  renderRateImage = imageSrc => {
    return (
      <Grid.Column
        only="computer"
        width={8}
        className={styles.priceImageWrapper}
        verticalAlign="top"
      >
        <Image
          size="huge"
          bordered
          verticalAlign="bottom"
          className={styles.priceImage}
          src={imageSrc}
        />
      </Grid.Column>
    );
  };

  checkIfDeal = rates => {
    return rates.find(rate => rate.isPackage) != null;
  };

  onShowRoomGalleryPopUp = key => {
    const { onShowRoomGalleryPopUp, rates } = this.props;
    const clickedRoom = rates && rates.find(r => r.roomId == key);
    onShowRoomGalleryPopUp(clickedRoom);
  };

  renderDesktopTable = () => {
    const { isRtl, titles, viewGallery, titleParam } = this.props;
    const { ratesAsGroups, finishedRendering } = this.state;
    const ratesAsGroupsKeys = ratesAsGroups && ratesAsGroups.keys();
    const keyArr = ratesAsGroupsKeys && Array.from(ratesAsGroupsKeys);

    return (
      <div
        className={cx(styles.ratesDataWrapper, {
          [styles.appeared]: finishedRendering
        })}
      >
        {keyArr &&
          keyArr.map((ratesGroupKey, rowIndex) => {
            const isDeal = this.checkIfDeal(ratesAsGroups.get(ratesGroupKey));
            const roomId =
              ratesAsGroups.get(ratesGroupKey)[0] &&
              ratesAsGroups.get(ratesGroupKey)[0].id;
            return (
              <div
                key={rowIndex + ratesGroupKey + roomId}
                className={cx(styles.rateData, {
                  [styles.deal]: isDeal,
                  [styles.rtl]: isRtl
                })}
              >
                <div className={styles.rateHeader}>
                  <div className={styles.rateName}>
                    {ratesGroupKey && (
                      <RawHTML
                        className={styles.rateNameTitle}
                        html={ratesAsGroups.get(ratesGroupKey)[0][titleParam]}
                      />
                    )}
                  </div>
                  {viewGallery && (
                    <div
                      className={styles.viewGallery}
                      onClick={() => this.onShowRoomGalleryPopUp(ratesGroupKey)}
                      onKeyDown={() =>
                        this.onShowRoomGalleryPopUp(ratesGroupKey)
                      }
                      role="button"
                      tabIndex="0"
                    >
                      {titles.ViewGallery}
                    </div>
                  )}
                </div>
                {isDeal && this.renderRibbon()}
                <div className={styles.plansWrapper}>
                  {ratesGroupKey &&
                    ratesAsGroups.get(ratesGroupKey) &&
                    ratesAsGroups
                      .get(ratesGroupKey)
                      .map(rate => this.renderRateRow(rate, isDeal))}
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  render() {
    return <React.Fragment>{this.renderDesktopTable()}</React.Fragment>;
  }
}

RatesTable.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  rates: PropTypes.array,
  showAvailability: PropTypes.bool,
  lowAvailabilityCount: PropTypes.number,
  onItemClick: PropTypes.func,
  onReadeMoreClick: PropTypes.func,
  ShowCancellationPolicy: PropTypes.bool,
  isIE: PropTypes.bool,
  isIos: PropTypes.bool,
  isMobileView: PropTypes.bool,
  showSimpleClubLoginModal: PropTypes.func,
  isClubActive: PropTypes.bool,
  clubUserLoggedIn: PropTypes.bool,
  clubPercentageDiscount: PropTypes.number,
  groupParam: PropTypes.string,
  titleParam: PropTypes.string,
  //shouldFilterAvailableRates: PropTypes.bool,
  onShowRoomGalleryPopUp: PropTypes.func,
  viewGallery: PropTypes.bool,
  isDealPage: PropTypes.bool,
  selectedPaxId: PropTypes.number,
  shouldGroupByPackageId: PropTypes.bool,
  displayPriceWithoutTaxes: PropTypes.bool,
  showPricePerNightThumb: PropTypes.bool
};

export default RatesTable;



// WEBPACK FOOTER //
// ./src/components/RatesTable/RatesTable.js